// Picklist counterpart to getNetworkFieldValue: distinguishes "not dirty"
// (raw form value missing) from "dirty clear" (raw form value === ""), so we
// can emit a null clear signal instead of dropping the field.
export const resolvePicklistId = (
	rawValue: unknown,
	resolvedId: string | undefined
): string | null | undefined => {
	if (rawValue === undefined || rawValue === null) return undefined;
	if (rawValue === '') return null;
	return resolvedId ?? null;
};
